import { useRef, useEffect } from "react";

function useInterval(callback, delay) {
    const intervalRef = useRef(null);
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const tick = () => savedCallback.current();
        intervalRef.current = setInterval(tick, delay);
        return () => window.clearInterval(intervalRef.current);
    }, [delay]);

    return intervalRef;
}

export default useInterval;
